export interface GeoPosition {
  lat: number,
  lon: number
}

export class GeoHelper {
    static GetCenterFromPositions(data: GeoPosition[]): GeoPosition {
      var furthestNorth = Math.max.apply(Math, data.map(function(o) { return o.lat; }))
      var furthestEast = Math.max.apply(Math, data.map(function(o) { return o.lon; }))
      var furthestSouth = Math.min.apply(Math, data.map(function(o) { return o.lat; }))
      var furthestWest = Math.min.apply(Math, data.map(function(o) { return o.lon; }))

      return {
        lat: (furthestNorth + furthestSouth) / 2,
        lon: (furthestEast + furthestWest) / 2
      };    
    }

    static findDistanceBetweenPoints(p1: GeoPosition, p2: GeoPosition) {
      var x0 = p1.lat - p2.lat;
      var y0 = p1.lon - p2.lon;
      return x0 * x0 + y0 * y0;
    }

    static findMaxDistanceBetweenPoints(data: GeoPosition[]) {
      var n = data.length;
      var maxm = 0;

      // Iterate over all possible pairs
      for (let i = 0; i < n; i++) {
        for (let j = i + 1; j < n; j++) {
          // Update maxm
          maxm = Math.max(maxm, GeoHelper.findDistanceBetweenPoints(data[i], data[j]));
        }
      }
      // Return actual distance
      return Math.sqrt(maxm);
    }

    
    static CalculateZoom(allLatLons: GeoPosition[], mapHeight: number, mapWidth: number) {
        var WORLD_DIM = { height: 256, width: 256 };
        var ZOOM_MAX = 21;
    
        function latRad(lat) {
            var sin = Math.sin(lat * Math.PI / 180);
            var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
            return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
        }
    
        function zoom(mapPx, worldPx, fraction) {
            return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        }
    
        var furthestNorth = Math.max.apply(Math, allLatLons.map(function(o) { return o.lat; }))
        var furthestEast = Math.max.apply(Math, allLatLons.map(function(o) { return o.lon; }))
        var furthestSouth = Math.min.apply(Math, allLatLons.map(function(o) { return o.lat; }))
        var furthestWest = Math.min.apply(Math, allLatLons.map(function(o) { return o.lon; }))

        var ne: GeoPosition = { lat: furthestNorth, lon: furthestEast }
        var sw: GeoPosition = { lat: furthestSouth, lon: furthestWest }
    
        var latFraction = (latRad(ne.lat) - latRad(sw.lat)) / Math.PI;
    
        var lngDiff = ne.lon - sw.lon;
        var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;
    
        var latZoom = zoom(mapHeight, WORLD_DIM.height, latFraction);
        var lngZoom = zoom(mapWidth, WORLD_DIM.width, lngFraction);
    
        return Math.min(latZoom, lngZoom, ZOOM_MAX);
    }
}
